// @flow

import React from 'react';
import type { Node } from 'react';
import { quiz as CONFIG_QUIZ } from 'Config';
import Logo from 'shared_components/common/logo/Logo';
import { HOCQuiz } from 'shared_hocs/quiz/Quiz';
import { LayoutDefault } from 'shared_components/layouts/Default';
import { BaseHeader } from '@riseart/layout';
import { QuizQuestionsContainer } from 'shared_components/quiz/containers/Questions';

const QUIZ_ID = CONFIG_QUIZ.resourceId;
const Quiz = HOCQuiz(QuizQuestionsContainer);

/**
 * QuizQuestionsPage
 *
 * @returns {*}
 * @constructor
 */
export default function QuizQuestionsPage(): Node {
  return (
    <LayoutDefault
      hasFooter={false}
      hasHeader
      headerComponent={<BaseHeader contentLeft={<Logo tag="h1" black />} />}
      showRecentArtworkWidget={false}
    >
      <Quiz id={QUIZ_ID} />
    </LayoutDefault>
  );
}
